var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.previewUnsupported)?_c('div',[_c('div',{attrs:{"id":"pdf-preview"}})]):_vm._e(),_vm._v(" "),(_vm.previewUnsupported)?_c('div',{staticClass:"alert alert-info"},[_vm._v("Your browser does not support PDF preview!")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }